module.exports = __webpack_public_path__ + "img/1.2200a64d.jpg";